import React from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from '../i18n';
import { getVisIsLoadingMap } from '../selectors';
import useSdmxStructure from './useSdmxStructure';

export default ({ isLoading }) => {
  const { isIncreased } = useSdmxStructure();
  const isLoadingMap = useSelector(getVisIsLoadingMap);

  let loading = null;
  let loadingProps = null;
  if (isLoading) {
    loading = isIncreased ? (
      <FormattedMessage id="de.visualisation.data.larger.loading" />
    ) : (
      <FormattedMessage id="de.visualisation.data.loading" />
    );
    loadingProps = isIncreased ? { isWarning: true } : {};
  } else if (isLoadingMap) {
    loading = <FormattedMessage id="de.vis.map.loading" />;
  }

  return { loading, loadingProps };
};
